<p-dialog
  [visible]="visible()"
  (visibleChange)="visibleChange.emit($event)"
  [header]="title()"
  [modal]="modal()"
  [style]="{ width: width() }"
  [draggable]="draggable()"
  [resizable]="resizable()"
  [closeOnEscape]="closeOnEscape()"
  (onHide)="close.emit()"
>
  <ng-content></ng-content>

  <ng-template pTemplate="footer" *ngIf="footerTemplate()">
    <ng-container [ngTemplateOutlet]="footerTemplate()"></ng-container>
  </ng-template>
</p-dialog>
